module.exports = __webpack_public_path__ + "img/2023-gq2.5736d8da.jpg";